export const SET_TOKEN = "SET_TOKEN";
export const SET_PROFILE = "SET_PROFILE";
export const SET_ACTIONS = "SET_ACTIONS";
